import { graphql } from "gql";

const ADMIN_USERS_SET_ACTIVE_MUTATION = graphql(`
  mutation AdminUsersSetActive($idList: [ID!]!, $active: Boolean!) {
    adminUsersSetActive(idList: $idList, active: $active) {
      ...User
    }
  }
`);

export default ADMIN_USERS_SET_ACTIVE_MUTATION;
